import { render, staticRenderFns } from "./NewFirma.vue?vue&type=template&id=6498ebc3&"
import script from "./NewFirma.vue?vue&type=script&lang=js&"
export * from "./NewFirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports